import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectors as appSelectors } from '../../../reducers/appReducer';
import { setProfiles } from '../../../actions/appActions';
import { getProfiles } from '../api';

/**
 * Custom hook per la gestione della lista profili con paginazione.
 * Gestisce il fetch e la sincronizzazione con lo store Redux.
 */
export function useProfiles() {
    const dispatch = useDispatch();
    const profiles = useSelector(appSelectors.getProfiles);
    const [isFetching, setIsFetching] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const perPage = 10;

    const fetchProfiles = useCallback(async (page = 1) => {
        setIsFetching(true);
        try {
            const res = await getProfiles(page, perPage);
            const responseData = res.data.data || res.data;
            const profilesData = Array.isArray(responseData) ? responseData : responseData.results || [];

            dispatch(setProfiles({ data: profilesData }));
            setCurrentPage(page);

            if (res.data.meta?.pagination) {
                setTotalPages(res.data.meta.pagination.total_pages);
                setTotalItems(res.data.meta.pagination.total);
            } else if (responseData.total !== undefined) {
                setTotalPages(Math.ceil(responseData.total / perPage));
                setTotalItems(responseData.total);
            }
        } catch (error) {
            console.error('Errore nel recupero dei profili:', error);
        } finally {
            setIsFetching(false);
        }
    }, [dispatch]);

    const handlePageChange = useCallback((page) => {
        fetchProfiles(page);
    }, [fetchProfiles]);

    return {
        profiles: Object.values(profiles),
        isFetching,
        fetchProfiles,
        currentPage,
        totalPages,
        totalItems,
        perPage,
        handlePageChange,
    };
}
